import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFields } from '../../custom-fields.interface';
import { CUSTOM_FIELDS_TYPES, CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS_MAP } from '../../custom-fields.constants';
import { ComputedFrom, DateFormatPipe } from '@certemy/common';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { ROLE_CODES } from 'constants/role.constants';
import { Selectors } from 'features/profiles-state/+state/profiles-state.state';
import { CUSTOM_FIELD_TYPES } from 'constants/constants';

@Component({
  selector: 'cm-instance-custom-field',
  templateUrl: './instance-custom-field.component.html',
  styleUrls: ['./instance-custom-field.component.scss'],
})
export class InstanceCustomFieldComponent implements OnInit {
  @Input() field: CustomFields.FieldInstance;
  @Input() readOnly = false;
  @Input() options;
  @Output() valueChange = new EventEmitter();
  NO_VALUE = 'No data';
  private roleId: number;
  readonly CUSTOM_FIELD_TYPES = CUSTOM_FIELD_TYPES;

  @ComputedFrom('field')
  get fieldValue() {
    const { type_id, value } = this.field;

    if (!value) {
      return this.NO_VALUE;
    }

    if (type_id === CUSTOM_FIELD_TYPES.DATE) {
      return this.dateFormatPipe.transform(value);
    }
    const isBooleanSelect = type_id === CUSTOM_FIELD_TYPES.BOOLEAN_SELECT;
    return isBooleanSelect ? CUSTOM_FIELDS_BOOLEAN_SELECT_OPTIONS_MAP[value] : value;
  }

  @ComputedFrom('roleId')
  get isProfessional(): boolean {
    return this.roleId === ROLE_CODES.PROFESSIONAL;
  }

  constructor(private store: Store<any>, private dateFormatPipe: DateFormatPipe) {}

  ngOnInit() {
    this.store
      .select(Selectors.currentProfile)
      .pipe(take(1))
      .subscribe(currentProfile => (this.roleId = currentProfile.role_id));
  }

  onValueChange(event) {
    this.valueChange.emit(event);
  }
}
